import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx"
import UserModel from "../../model/UserModel";
import {ISelect} from "../../interface/ISelect";


export class PageRegEmployeeStore {
    private rootStore: RootStore | undefined;

    private edit = false;
    public isShow = false;
    private id = 0;
    private TradePoint = [];

    public inputs: any;

    public error: string = '';
    public redirect: boolean = false;

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
        this.defaultData();
    }

    init(id = 0) {
        if (id) {
            this.edit = true;
            this.id = id;
        } else {
            this.edit = false;
            this.id = 0;
            this.defaultData();
        }
        this.getTradePoint();
        this.redirect = false;
        for (let code in this.inputs) {
            // @ts-ignore
            let elm = this.inputs[code];
            elm.value = '';
        }


        let userId = this.rootStore?.mainStore.user.id;
        this.isShow = id !== userId;
    }

    @action
    defaultData() {
        this.inputs = {
            TradePoint: {
                code: 'TradePoint',
                type: "text",
                title: 'Торговая точка',
                tooltip: 'Торговая точка',
                option: [],
                error: '',
                value: '',
                valueId: [{value: 0, label: 'Выберите торговую точку'}],
                server: true,
                required: true,
            },
            phone: {
                code: 'phone',
                type: "text",
                title: 'Телефон',
                tooltip: 'Телефон',
                error: '',
                value: '',
                valueId: 0,
                server: true,
                isMask: true,
                mask: '+375 (99) 999-99-99',
                required: true,
            },
            FIO: {
                code: 'FIO',
                type: "text",
                title: 'ФИО',
                tooltip: 'ФИО',
                error: '',
                value: '',
                valueId: 0,
                required: true,
                server: true,
            },
            post: {
                code: 'post',
                type: "text",
                title: 'Должность',
                tooltip: 'Должность',
                error: '',
                value: '',
                required: true,
                server: true,
            },
            email: {
                code: 'email',
                type: "email",
                title: 'Адрес электронной почты',
                tooltip: '@ домен почтового клиента',
                error: '',
                value: '',
                valueId: 0,
                required: true,
                server: true,
            },
            password: {
                code: 'password',
                type: "password",
                title: 'Новый пароль (пустое поле, пароль не меняется)',
                tooltip: 'Новый пароль (пустое поле, пароль не меняется)',
                error: '',
                value: '',
                valueId: 0,
                required: true,
                server: true,
            },
            password2: {
                code: 'password2',
                type: "password",
                title: 'Повторите пароль',
                tooltip: 'Повторите пароль',
                error: '',
                value: '',
                valueId: 0,
                required: true,
                server: false,
            }
        }
    }

    setUser = (result: any) => {
        this.inputs.FIO.value = [result?.data?.lastName, result?.data?.firstName, result?.data?.secondName].join(' ');

        this.inputs.email.value = result.data.email;
        let idPoints = result.data.tradePointIds[0];
        // @ts-ignore
        let data = this.inputs.TradePoint.option.filter(item => item.value === idPoints);
        // @ts-ignore
        this.inputs.TradePoint.value = data[0]?.value;
        // @ts-ignore
        this.inputs.TradePoint.valueId = {value: data[0]?.value, label: data[0]?.label};

        this.inputs.post.value = result.data.post;
        this.inputs.phone.value = result?.data?.phone;

        this.inputs.password.required = false;
        this.inputs.password2.required = false;

    }

    falseRedirect = () => {
        this.redirect = false;
    }

    @action
    checkTradePoint(isMessage = false) {
        let result = '';
        let id = this.inputs.TradePoint.value;
        if (!id) {
            if (isMessage) {
                this.inputs.TradePoint.error = 'Выберите торговую точку из списка!';
            }
            result = '';
        } else {
            // @ts-ignore
            result = id;
        }
        return result;
    }


    @action
    onSubmitForm = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        let data = [];
        for (let code in this.inputs) {
            // @ts-ignore
            let item = this.inputs[code];
            if (item.server) {
                data.push(item);
            }
        }
        let dt: any = {};
        data.map((item: any) => {
            dt[item.code] = item.value;
            return item;
        });
        let id = this.checkTradePoint(true);
        if (this.validate() && id) {

            if (this.isShow) {
                dt['TradePoint'] = id;
            } else {
                delete dt['TradePoint'];
            }

            if (this.isShow) {
                dt['type'] = 'clientUser';
            } else {
                delete dt['type'];
            }
            dt['siteId'] = this.rootStore?.mainStore?.user?.siteId;

            if (this.edit) {
                if (!dt.password.length) {
                    delete dt.password;
                }
                UserModel.updateUser(this.id,
                    dt,
                    this.setSubmit,
                    this.setError
                );
            } else {
                UserModel.create(
                    dt,
                    this.setSubmit,
                    this.setError
                );
            }

        }
        return false;
    }

    @action validate() {
        let result = true;
        // PASSWORD
        let i1 = this.inputs.password;
        let i2 = this.inputs.password2;
        if (i1 !== undefined && i2 !== undefined) {

            if (this.edit) {
                if (!i1.value.length && !i2.value.length) {
                    return result;
                }
            }

            if (i1.value !== i2.value) {
                i2.error = 'Неверное потверждение пароля!';
                result = false;
            } else {
                i2.error = '';
            }
        }
        if (i1.value.length < 6 || i1.value.length > 12) {
            i1.error = 'Длина пароля от 6 до 12 символов';
            result = false;
        }
        return result;
    }

    @action
    setSubmit = (result: any) => {
        this.redirect = true;
    }

    @action
    onChangeInput = (e: { target: { value: string; }; }, item: any) => {
        item.value = e.target.value;
    }

    @action
    onChangeInputTradePoint = (e: any, item: any) => {
        item.valueId = e;
        item.value = e.value;
    }

    @action getTradePoint() {
        UserModel.getAllTradePoint(this.setTradePoint, this.setError)
    }

    @action setTradePoint = (result: any) => {
        this.inputs.TradePoint.option = [];
        let r: ISelect[] = [];
        if (Array.isArray(result.data)) {
            result.data.map((item: any) => {
                r.push({
                    label: item.name.trim(),
                    value: item.id,
                })
                return item;
            });
        }
        // @ts-ignore
        this.inputs.TradePoint.option = r;

        if (this.edit) {
            UserModel.getInfoUser(this.id, this.setUser, this.setError);
        }
    }

    @action
    setError = (error: any) => {
        if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            error.response.data.message !== undefined
        ) {
            this.error = String(error.response.data.message);
        } else if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            Array.isArray(error.response.data)
        ) {
            let el = {
                error: ''
            };
            error.response.data.map((item: any) => {
                // @ts-ignore
                el = this.inputs[item.code];
                if (el !== undefined) {
                    el.error = item.error;
                }
                return item;
            });
        } else if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            !Array.isArray(error.response.data)
        ) {
            return String(error.response.data);
        }
    }

}